// Banky Nieuw WP1.3: footer (snippets/banky-footer-columns.liquid).
// "Cookie-instellingen" heropent de cookiebalk. Eerst krijgt de cookiebalk van WP1.2 het event
// banky:cookie-instellingen (die roept preventDefault aan als hij het afhandelt); anders toont deze knop Halo's
// <privacy-bar> (Shopify Customer Privacy API, methode show). Staat er geen cookiebalk op de pagina, dan gaat de knop
// naar het privacybeleid (data-terugval).
(() => {
  if (window.bankyVoet) return;
  window.bankyVoet = true;
  document.addEventListener('click', (e) => {
    const knop = e.target.closest('[data-banky-cookie-instellingen]');
    if (!knop) return;
    const ev = new CustomEvent('banky:cookie-instellingen', {cancelable: true, detail: {knop}});
    if (!document.dispatchEvent(ev)) return;
    const balk = document.querySelector('privacy-bar');
    if (balk) {
      if (typeof balk.show === 'function') balk.show();
      else balk.hidden = false;
      const eerste = balk.querySelector('[data-action="accept"], [data-action="decline"], button');
      if (eerste) eerste.focus();
      return;
    }
    if (knop.dataset.terugval) window.location.href = knop.dataset.terugval;
  });
})();
